export * from "./buffer.pure";
export * from "./buffer.types";
import { RegisterVertexBuffer } from "./buffer.pure";
RegisterVertexBuffer();
//# sourceMappingURL=buffer.js.map